import styled from 'styled-components'

export const ButtonContent = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
`
